import { IAppState } from '../common/state';

export function selectIsDevCardRedesignEnabled(state: IAppState): boolean {
  return state.featureToggle.isDevCardRedesignEnabled;
}
